<template>
  <v-container id="bid-paperwork" fluid tag="section" class="main-container">
    <idc-component-bid-paperwork
      :settings="settings"
      :can-edit="false"
      :can-read="canRead"
      :can-delete="false"
      :url-specification="urlSpecification"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardInactiveBidPaperwork',
    components: {
      IdcComponentBidPaperwork: () => import('@/components/idc/bids/Paperwork'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      urlSpecification: {
        type: String,
        default: () => Path.SALES_NO_BIDS_SPEC,
      },
      urlSummary: {
        type: String,
        default: () => Path.SALES_NO_BIDS_SUMMARY,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
